import { PaddingIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useGeckoAnalytics } from 'features/analytics'
import { useKestrel } from 'features/kestrelViewer'
import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import React from 'react'
import styled from 'styled-components'

const StyledPaddingIcon = styled(PaddingIcon)`
  path {
    opacity: 1;
  }
`

export const Toggle2DPlaneButton: React.FC = () => {
  const { sendCommand, is2DPlaneModeActive, setIs2DPlaneModeActive } =
    useKestrelViewerContext()
  const { kestrelModel } = useKestrel()
  const { trackButtonClicked } = useGeckoAnalytics()

  const color = is2DPlaneModeActive ? 'rgb(0, 255, 0)' : 'rgb(200, 200, 200)'

  return (
    <TooltipWrapper side={'top'} offset={5} label={'Toggle 2D Plane'}>
      <ViewToggle
        onClick={() => {
          const newIs2DPlaneModeActive = !is2DPlaneModeActive
          setIs2DPlaneModeActive(newIs2DPlaneModeActive)
          if (sendCommand) {
            sendCommand({
              command: 'set2DPlaneModeActive',
              is2DPlaneModeActive: newIs2DPlaneModeActive,
            })
          }
          trackButtonClicked({
            button_name: 'kestrel_toggle_2d_plane',
            kestrel_model_id: kestrelModel?.data.kestrel_model_id,
          })
        }}>
        <StyledPaddingIcon width={22} height={22} style={{ color: color }} />
      </ViewToggle>
    </TooltipWrapper>
  )
}
